var _style, _path, _g, _g2, _g3, _g4, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFiterBottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 190.2 71.2",
    style: {
      enableBackground: "new 0 0 190.2 71.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00C1DE;}\r\n\t.st1{fill:#FFDA00;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.6,21.2h10.2v11.3H85.6v21.1c0,4.7,1.2,5.9,5.9,5.9c1.5,0,2.8-0.1,4.3-0.4V70c-2.3,0.4-5.4,0.5-8.1,0.5 c-8.5,0-15.9-2-15.9-12V32.5h-8.4V21.2h8.4V4.1h13.9L85.6,21.2L85.6,21.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.6,48c0.4,8.8,4.7,12.8,12.4,12.8c5.6,0,10.1-3.4,11-6.6h12.2c-3.9,11.9-12.2,17-23.7,17 c-15.9,0-25.8-11-25.8-26.6c0-15.2,10.5-26.7,25.8-26.7c17.2,0,25.5,14.5,24.6,30.1H113.6z M136.2,39.2c-1.3-7-4.3-10.8-11.1-10.8 c-8.8,0-11.3,6.8-11.6,10.8H136.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.6,19.3h13.2v9.4h0.2c2.5-6.4,9.4-10.8,16.1-10.8c1,0,2.1,0.2,3,0.5v12.9c-1.3-0.3-3.3-0.5-5-0.5 c-10.2,0-13.7,7.3-13.7,16.3v22.8h-13.9V19.3z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.3,32.5H0V21.2h8.3v-5.9C8.3,6.5,13.9,0,25.2,0c2.5,0,5,0.3,7.3,0.4v10.4c-1.7-0.2-3.3-0.3-5.1-0.3 c-3.7,0-5.3,1.6-5.3,5.8v5h9.6v11.3h-9.6v37.3H8.3V32.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.7,21.4h13.8v48.2H41.7V21.4z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.9,8.6c0,4.5-3.7,8.2-8.2,8.2s-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2C53.3,0.4,56.9,4.1,56.9,8.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFiterBottom);
export default __webpack_public_path__ + "static/media/logo-fiter-bottom.8d852856b90b49bdd6dd87ed59b6f91a.svg";
export { ForwardRef as ReactComponent };